/**
 * Splits an array into groups of a specified size.
 * If the array cannot be evenly divided, the last group will be padded with `fillValue`.
 *
 * @param array - The array to split into groups.
 * @param groupSize - The size of each group.
 * @param fillValue - The value to use for padding the last group (if needed).
 * @returns An array of groups.
 */
export function inGroupsOf<T>(
  array: T[],
  groupSize: number,
  fillValue: T | null | false = null
): T[][] {
  if (groupSize <= 0) {
    throw new Error('groupSize must be greater than 0');
  }

  const result: T[][] = [];
  for (let i = 0; i < array.length; i += groupSize) {
    const group = array.slice(i, i + groupSize);

    if (fillValue !== false) {
      while (group.length < groupSize) {
        group.push(fillValue as T);
      }
    }

    result.push(group);
  }

  return result;
}
